import { createClient } from '@supabase/supabase-js';

// Note: In production, these should be environment variables
// For now, we'll use placeholder values that should be replaced with actual Supabase project credentials
const supabaseUrl = process.env.REACT_APP_SUPABASE_URL || '';
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY || '';

export const supabase = supabaseUrl && supabaseAnonKey 
  ? createClient(supabaseUrl, supabaseAnonKey)
  : null;

/**
 * Submit early access signup to Supabase
 * @param {Object} data - Signup data
 * @param {string} data.name - User's name (ghost handle)
 * @param {string} data.email_address - User's email address
 * @param {string} [data.selected_gig] - Selected gig option
 * @returns {Promise<Object>} Result of the signup operation
 */
export const submitEarlyAccess = async ({ name, email_address, selected_gig }) => {
  if (!supabase) {
    // Mock mode when Supabase is not configured
    console.warn('Supabase not configured. Using mock mode.');
    console.log('Form data (mock):', { name, email_address, selected_gig });
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: { name, email_address, selected_gig },
          error: null,
        });
      }, 1000);
    });
  }

  try {
    const { data, error } = await supabase
      .from('early_access')
      .insert([{ name, email_address, selected_gig }])
      .select();

    return { data, error };
  } catch (error) {
    return { data: null, error };
  }
};

/**
 * Submit contact us form to Supabase
 * @param {Object} data - Contact form data
 * @param {string} data.name - User's name
 * @param {string} data.email - User's email address
 * @param {string} data.message - User's message
 * @returns {Promise<Object>} Result of the contact submission
 */
export const submitContactUs = async ({ name, email, message }) => {
  if (!supabase) {
    // Mock mode when Supabase is not configured
    console.warn('Supabase not configured. Using mock mode.');
    console.log('Contact form data (mock):', { name, email, message });
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve({
          data: { name, email, message },
          error: null,
        });
      }, 1000);
    });
  }

  try {
    const { data, error } = await supabase
      .from('contact_us')
      .insert([{ name, email, message }])

    return { data, error };
  } catch (error) {
    return { data: null, error };
  }
};
